export class FetchJsonError extends Error {
  status: number
  data: unknown

  constructor(message: string, status: number, data: unknown) {
    super(message)
    this.name = "FetchJsonError"
    this.status = status
    this.data = data
  }
}

type FetchJsonOptions = RequestInit & {
  fallbackMessage?: string
}

export async function fetchJson<T>(input: RequestInfo | URL, init?: FetchJsonOptions): Promise<T> {
  const { fallbackMessage, ...requestInit } = init || {}
  const res = await fetch(input, requestInit)
  const data = await res.json().catch(() => null)

  if (!res.ok) {
    const message =
      (typeof data === "object" && data && "error" in data && typeof (data as { error?: unknown }).error === "string"
        ? (data as { error: string }).error
        : null) || fallbackMessage || "Не вдалося виконати запит"

    throw new FetchJsonError(message, res.status, data)
  }

  return data as T
}
